import type { ReactNode } from "react";

interface PageTitleRowProps {
  title: string;
  /** The page's own controls (a filter button, a view toggle), at the trailing
   * end. Omit when the page has none. */
  children?: ReactNode;
}

/**
 * The strip under the project header that names a page and carries that page's
 * controls. Issues, Plans and Photos share it so the title sits in the same
 * place at the same size on each. See [[page-title-row.spec]].
 */
export function PageTitleRow({ title, children }: PageTitleRowProps) {
  return (
    <div className="flex h-14 shrink-0 items-center justify-between px-4">
      <h1 className="text-xl font-semibold tracking-[-0.02em]">{title}</h1>
      {children}
    </div>
  );
}
